import utcToZonedTime from 'date-fns-tz/utcToZonedTime'
import format from 'date-fns-tz/format'
import addMinutes from 'date-fns/addMinutes'

/**
 * Check that start time falls between supported hours 9am monday in Sydney to 5pm Friday in Denver
 * @param start - An ISO string - implicitly UTC
 */
export const isSupported = ( start: string ): boolean => {

  const sydneyTime = utcToZonedTime(start, "Australia/Sydney" )

  switch( format( sydneyTime, 'e') ) { //1-7 = sunday - saturday
    case '1': //Sunday
      return false;

    case '2': // Monday
      if( parseInt( format(sydneyTime, 'HH' ) ) >= 9 ) return true
      break

    case '7': // Saturday
      // switch to Denver time, Boise is the standard for Mountain Time - if they are still working you are okay
      // subtract a minute - so we can just check hours are less than and not worry about minutes
      const denverTime = utcToZonedTime( addMinutes( new Date( start ), -1 ), "America/Boise" )
      if( parseInt( format( denverTime, 'e')) === 6 && parseInt( format(denverTime, 'HH' ) ) < 17 ) return true
      break
    default:
      return true
  }

  return false
}

export default isSupported
